
<div class="container">
    <div class="row  justify-content-center">
        <div class="box col-12 col-lg-8">
            <div class="box__cont box__cont--verify">
                <div class="box__title box__title--otp">
                    <h1>WELCOME TO PARTNERS PORTAL</h1>
                    <h2 style="word-break:break-word"><b>{{email}}</b></h2>
                    <h2>ATRAM will register this number as part of the initial account registration. You may later choose to update.</h2>
                </div>
                <div class="box__form">
                    <div class="col-12 box__field box__field--otp">
                        <div class="col-12 box__field">
                            <atram-textbox [parentFormGroup]="searchFormGroup"
                                            type="text"
                                            controlName="mobileNo"
                                            label=""
                                            placeholder=""
                                            maxlength="10"
                                            [number-only]="true"
                                            [isError]="!searchFormGroup.get('mobileNo')?.valid && searchFormGroup.get('mobileNo')?.touched"
                                            [isRequired]="true"
                                            [showPhNumber]="true">
                            </atram-textbox>
                            <h3 class="box__error-notif" *ngIf="!searchFormGroup.get('mobileNo')?.valid && searchFormGroup.get('mobileNo')?.touched">Not a valid mobile number.</h3>
                        </div>
                    </div>
                    <!-- <div class="col-12 box__field">
                        <atram-textbox [paresntFormGroup]="searchFormGroup"
                                        type="text"
                                        controlName="email"
                                        label="E-mail"
                                        placeholder="E-mail"
                                        [isRequired]="true">
                        </atram-textbox>
                    </div>
                    <div class="col-12 box__field">
                        <atram-textbox [parentFormGroup]="searchFormGroup"
                                        type="text"
                                        controlName="password"
                                        label="Password"
                                        placeholder="Password"
                                        [isRequired]="true">
                        </atram-textbox>
                    </div> -->
                    <!-- <div class="col-12 box__hyperlink">
                        <span>Forgot Password?</span>
                    </div> -->
                    <div class="row justify-content-center">
                        <div class="col-12">
                            <div class="buttons">
                                <div class="row">
                                    <!-- <div class="buttons__first col-12 col-sm-6">
                                        <atram-button buttonType="default"
                                            label="Back to Sign In"
                                            componentClass="btn-submit"
                                            (on-click)="onClickHamburger()">
                                        </atram-button>
                                    </div> -->
                                    <!-- <div class="col-12 col-sm-6 box__hyperlink">
                                        <span (click)="goToSignUp()">Return to Signup</span>
                                    </div>                                  -->
                                    <div class="text-right col-12">
                                        <atram-button label="Next"
                                            componentClass="btn-submit"
                                            (on-click)="proceed()">
                                        </atram-button>  
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<atram-modal #atramModal></atram-modal>
